import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApiRequestBody, OpalApiRequestParams } from '../../schema'

type CreateWorkflowParams = OpalApiRequestParams<'CreateWorkflowsV2'>
type CreateWorkflowRequestBody = OpalApiRequestBody<'CreateWorkflowsV2'>

export const createWorkflow = async ({
  params,
  requestBody,
}: {
  params: CreateWorkflowParams
  requestBody: CreateWorkflowRequestBody
}) => {
  const url = new URL('/workflows/v2/workflows', window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
